import styled from 'styled-components';
import { StyledButton as Button } from '../CommonComponents/Button';
import Icon from '../CommonComponents/Icon';

export const Wrapper = styled.div`
  background: #fff;
  border: 1px solid #e3e1e1;
  border-radius: ${props => props.theme.legacy.borderRadius};
  padding: 30px 45px;
  position: relative;
`;

export const AddButton = styled(Button.Secondary)`
  margin: 15px auto;
  padding: 20px 40px;
  display: block;
  border: 1px solid #8F959F;
  border-radius: ${props => props.theme.legacy.borderRadius};
  font-weight: 600;
  color: #494F5A;
`;

export const EditButton = styled(Button.Link)`
  position: absolute;
  top: 30px;
  right: 45px;
  font-size: 1.2em;

  ${Icon} {
    color: #afb0b5;
  }
`;

export const ExecutiveSummaryTitle = styled.div`
  font-weight: 600;
  letter-spacing: -0.3px;
  color: #4b4d4e;
  margin-bottom: 15px;
`;

export const ExecutiveSummaryMessage = styled.div`
  line-height: 29px;
  letter-spacing: -0.3px;
  color: #4b4d4e;
  white-space: pre-wrap;
`;
